module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQJFM5q2f4AAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAxElEQVRIS7WTSw7CMAxE0yUSJ0LiHlyEDXD3QjIZufnaCemTvGg9nidVqptj29NRGQr/2Pbn+xPGcIfA43YNo4QjIjBIUoFNkgoMolEJ8idK2gI/3MfwEYuExzILJdi97pcwfOYYBR4sS0mtnODZUE4QyiWpIIfFajmpSwYKerCoJfkLlObfe5EkLT8K/Ej5lKBXLvv6qCDYLq/BfS8TQGis3CM/Vyc/W+5BTpHgZSmwUpMUiIAHcWGEN81bNbCCM8qd+wKl5FA91E9AqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/crafting-icon.png
// module id = 487
// module chunks = 0